/* eslint-disable */
import gsap from "gsap";
import LazyLoad from "vanilla-lazyload";
import inView from "in-view";
import Isotope from "isotope-layout";
import {} from "isotope-fit-columns";
import Flickity from "flickity";
import lottie from "lottie-web";
import barba from "@barba/core";


const HTML = document.querySelector("html");

function sleep(delay) {
  return new Promise((resolve) => setTimeout(resolve, delay))
}

class App {
  constructor() {
    this.lazyload = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-lazy",
      threshold: window.innerHeight * 0.8,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains("js-lazy-error-placeholder")) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == undefined) {
          const figure = $el.closest("figure");
          if (figure) figure.classList.add("img-is-loaded");
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest("figure");
        if (figure) figure.classList.add("img-is-loaded");
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });

    // MENU
    const toggleMenu = document.querySelectorAll(".toggle-menu");
    if (toggleMenu) {
      toggleMenu.forEach((el) => {
        el.addEventListener("click", (e) => {
          e.preventDefault();
          HTML.classList.toggle("open-menu");
        });
      });
    }

    // MENU
    const toggleConcert = document.querySelectorAll(".toggle-concerts");
    if (toggleConcert) {
      toggleConcert.forEach((el) => {
        el.addEventListener("click", (e) => {
          e.preventDefault();
          HTML.classList.toggle("open-concert");
        });
      });
    }

    this.progresstime();
    this.bodymovin();
    this.asynchroneLoaded();
    this.gridHours();
    this.sliderScreen();
    this.init();
  }

  asynchroneLoaded() {
    const _ = this;
    const header = document.querySelector(".main-header");

    if( !document.querySelector('[data-barba]')) return;

    barba.hooks.after(() => {
      if (typeof gtag !== "undefined") {
        gtag("event", "page_view", {
          page_title: document.title,
          page_location: location.href,
          page_path: location.pathname,
        });
      }
    });

    barba.init({
      timeout: 15000,
      transitions: [
        {
          name: "default-transition",
          leave(data) {
            HTML.classList.add("no-event");
            HTML.classList.remove("open-menu", "open-filter", "open-concert");

            if (data.current.namespace == "category") {
              return leaveCategory(data);
            }
            if (data.current.namespace == "single") {
              return leaveSingle(data);
            }
            return gsap.to(data.current.container, {
              opacity: 0,
              duration: 0.3,
              onComplete: () => {
                window.scrollTo(0, 0);
                _.unmount();
              },
            });
          },
          enter(data) {
            _.lazyload.update();
            HTML.classList.remove("no-event");

            const form = data.next.container.querySelector(".wpcf7 form");
            if (form) wpcf7.init(form);

            /** HIDE MENU IF NEXT NAMESPACE IS SINGLE */
            if (data.next.namespace == "single") {
              gsap.to(header, {
                duration: 0.3,
                autoAlpha: 0,
                y: "-2rem",
                ease: "circ.inOut",
              });
            } else {
              gsap.to(header, {
                duration: 0.3,
                autoAlpha: 1,
                y: "0rem",
                ease: "circ.inOut",
              });
            }

            return gsap.from(data.next.container, {
              opacity: 0,
              duration: 0.3,
              onComplete: () => {
                _.init(data.next.container);
                gsap.set(data.next.container, { clearProps: "all" });
              },
            });
          },
        },
      ],
    });

    function leaveCategory(data) {
      const iso = Isotope.data(".list-articles");
      const tl = gsap.timeline({
        paused: true,
        onComplete: () => {
          window.scrollTo(0, 0);
          _.unmount();
        },
      });

      // HIDE HEADER LISTING
      const catHeader =
        data.current.container.querySelector(".category-header");
      if (catHeader) {
        tl.to(
          catHeader.querySelector("figure"),
          {
            duration: 0.5,
            autoAlpha: 0,
            y: "-20%",
            ease: "circ.in",
          },
          "start"
        )
          .to(
            catHeader.querySelector(".main-logo"),
            {
              duration: 0.3,
              autoAlpha: 0,
            },
            "start"
          )
          .to(
            catHeader.querySelectorAll(".nav li"),
            {
              duration: 0.3,
              autoAlpha: 0,
              x: "-1.5rem",
              stagger: 0.1,
            },
            "start"
          );
      }

      // HIDE FOOTER LISTING
      const footer = data.current.container.querySelector(".main-footer");
      if (footer) {
        const navs = footer.querySelectorAll(".nav");
        tl.to(
          navs[0],
          {
            duration: 0.3,
            x: "-4rem",
            autoAlpha: 0,
            ease: "circ.in",
          },
          "start"
        ).to(
          navs[1],
          {
            duration: 0.3,
            x: "4rem",
            autoAlpha: 0,
            ease: "circ.in",
          },
          "start+=0.1"
        );
      }

      // HIDE CLOSURE
      const closure = data.current.container.querySelector(".main-closure");
      if (closure) {
        tl.to(closure, { duration: 0.3, autoAlpha: 0, y: "1.5rem" }, "start");
      }

      // Get col 1 2 3 and 4
      const items = iso.filteredItems;
      const w = iso.size.width;
      let wCol = w / 4;
      if (window.innerWidth < 768) {
        wCol = w;
      } else if (window.innerWidth < 1024) {
        wCol = w / 2;
      }
      if (items) {
        items.forEach((item) => {
          const dir =
            item.position.x >= wCol * 3 ||
            (item.position.x >= wCol && item.position.x < wCol * 2)
              ? 1
              : -1;
          tl.to(
            item.element,
            {
              y: `${dir * 4}rem`,
              ease: "circ.in",
              duration: 0.3,
              autoAlpha: 0,
            },
            "start"
          );
        });
      }

      return tl.play();
    }
    function leaveSingle(data) {
      const tl = gsap.timeline({
        paused: true,
        onComplete: () => {
          window.scrollTo(0, 0);
          _.unmount();
        },
      });

      /** HIDE CONTENT */
      const content = data.current.container.querySelector(".content");
      if (content) {
        tl.to(
          content,
          {
            duration: 0.4,
            autoAlpha: 0,
            y: "-3rem",
            ease: "power.in",
          },
          "start"
        );
      }

      /** HIDE TRIGGER */
      const trigger = data.current.container.querySelector(".trigger");
      if (trigger) {
        tl.to(
          trigger,
          {
            autoAlpha: 0,
            x: "2rem",
          },
          "start"
        );
      }

      /** HIDE DECOR */
      const decor1 = data.current.container.querySelector(".decor1");
      const decor2 = data.current.container.querySelector(".decor2");
      if (decor1 && decor2) {
        tl.to(
          decor2,
          {
            autoAlpha: 0,
            x: "2rem",
            y: "2rem",
            ease: "expo.in",
          },
          "start"
        ).to(
          decor1,
          {
            autoAlpha: 0,
            x: "-2rem",
            y: "-2rem",
            ease: "expo.in",
          },
          "start+=0.1"
        );
      }

      return tl.play();
    }
  }

  unmount() {}

  init(container = document) {
    this.poll();
    this.slider();
    this.grid(container);
    this.sticky();
    this.inViewport();
  }

  progresstime() {
    const items = document.querySelectorAll(".concert-item .hover");

    if (items) {
      items.forEach((item) => {
        const start = new Date(item.dataset.start).getTime();
        const end = new Date(item.dataset.end).getTime();
        const currentDate = Date.now();

        const percent = (currentDate - start) / (end - start);

        console.log((end - currentDate) / 1000);

        gsap.set(item, {
          clipPath: `polygon(0 0, ${percent * 100}% 0, ${
            percent * 100
          }% 100%, 0% 100%)`,
        });

        gsap.to(item, {
          clipPath: `polygon(0 0, 100% 0, 100% 100%, 0% 100%)`,
          duration: (end - currentDate) / 1000,
        });
      });
    }
  }

  slider() {
    const sliders = document.querySelectorAll(".slider");
    if (sliders) {
      sliders.forEach((slider) => {
        new Flickity(slider, {
          cellAlign: "left",
          contain: true,
          prevNextButtons: false,
          pageDots: false,
          watchCSS: true,
        });
      });
    }
  }

  grid(parent = document) {
    const grids = parent.querySelectorAll(".list-articles");

    if (grids) {
      grids.forEach((grid) => {
        const iso = new Isotope(grid, {
          itemSelector: ".item",
        });

        /** Adapte delay */
        function adaptDelay() {
          // Get col 1 2 3 and 4
          const items = iso.filteredItems;
          const w = iso.size.width;
          const wCol = w / 4;
          if (items) {
            items.forEach((item) => {
              if (item.position.x >= wCol * 3) {
                item.element.classList.add("d-300");
              } else if (
                item.position.x >= wCol * 2 &&
                item.position.x < wCol * 3
              ) {
                item.element.classList.add("d-200");
              } else if (
                item.position.x >= Number(wCol) &&
                item.position.x < wCol * 2
              ) {
                item.element.classList.add("d-100");
              }
            });
          }
        }

        adaptDelay();

        const filters = parent.querySelectorAll("[data-filter]");
        const toggles = parent.querySelectorAll(".toggle-filter");
        if (toggles) {
          toggles.forEach((toggle) => {
            toggle.addEventListener("click", (e) => {
              e.preventDefault();

              HTML.classList.toggle("open-filter");
            });
          });
        }

        if (filters) {
          filters.forEach((filter) => {
            filter.addEventListener("click", (e) => {
              e.preventDefault();

              if (filter.classList.contains("active")) {
                return false;
              }

              const target = filter.dataset.filter;

              if (toggles) {
                toggles.forEach((toggle) => {
                  if (target != "item") {
                    toggle.classList.add("active-badge");
                  } else {
                    toggle.classList.remove("active-badge");
                  }
                });
              }

              HTML.classList.remove("open-filter");

              filters.forEach((f) => {
                f.classList.remove("active");
              });

              filter.classList.add("active");

              iso.arrange({
                filter: `.${target}`,
              });
            });
          });
        }
      });
    }
  }

  poll() {
    const polls = document.querySelectorAll(".wp-polls:not(.is-ready)");

    if (polls) {
      polls.forEach((poll) => {
        poll.classList.add("is-ready");

        const btn = poll.querySelector("[data-pollid]");
        if (btn) {
          btn.addEventListener("click", (e) => {
            e.preventDefault();
            if (typeof poll_vote === "function") {
              poll_vote(btn.dataset.pollid);

              setTimeout(() => {
                const iso = Isotope.data(".list-articles");
                iso.arrange();
              }, 2000);
            }
          });
        }
      });
    }
  }

  inViewport() {
    // In viewport
    inView.offset({
      bottom: window.innerHeight * 0.08,
    });
    inView(".js-reveal:not(.old-content):not(.is-visible")
      .on("enter", function (elt) {
        elt.dispatchEvent(new Event("inview"));
        elt.classList.add("is-visible");
        elt.classList.remove("not-visible");

        const video = elt.querySelector("video");

        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay == "true") ||
          (video && video.dataset.autoplay == "true")
        ) {
          const v = video || elt;
          const playPromise = v.play();
          if (playPromise !== null) {
            playPromise.catch(() => {
              v.play();
            });
          }
        }
      })
      .on("exit", function (elt) {
        const video = elt.querySelector("video");
        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay != "") ||
          (video && video.dataset.autoplay != "")
        ) {
          const v = video || elt;
          v.pause();
        }

        elt.dispatchEvent(new Event("outview"));
        elt.classList.add("not-visible");
      });
  }

  /**
   * Sticky element when in top viewport
   */
  sticky() {
    const stickys = document.querySelectorAll("[data-sticky]:not(.is-ready)");

    if (window.innerWidth < 768) return false;

    if (stickys) {
      stickys.forEach((el) => {
        el.classList.add("is-ready");

        const parent = el.dataset.stickyContainer
          ? document.querySelector(el.dataset.stickyContainer)
          : el.parentElement;

        window.addEventListener("resize", (e) => {
          window.dispatchEvent(new Event("scroll"));
        });

        window.addEventListener("scroll", (e) => {
          const pos = el.getBoundingClientRect();
          const pPos = parent.getBoundingClientRect();
          const offset = el.dataset.stickyOffset
            ? document.querySelector(el.dataset.stickyOffset).offsetHeight
            : 0;
          const container = el.dataset.stickyContainer
            ? document.querySelector(el.dataset.stickyContainer)
            : false;
          const containerPos = container
            ? container.getBoundingClientRect()
            : 0;

          // Now sticky
          if (pPos.top - offset <= 0) {
            el.style.width = `${pPos.width}px`;
            if (container && containerPos.bottom - pos.height - offset <= 0) {
              el.style.position = "absolute";
              el.style.top = `auto`;
              el.style.bottom = `0px`;
              el.style.left = `0px`;
            } else {
              el.style.position = "fixed";
              el.style.top = `${offset}px`;
              el.style.bottom = `auto`;
              el.style.left = `${pPos.x}px`;
            }
          } else {
            el.style.position = "absolute";
            el.style.top = `0px`;
            el.style.bottom = `auto`;
            el.style.left = `0px`;
            el.style.width = `100%`;
          }
        });

        window.dispatchEvent(new Event("scroll"));
      });
    }
  }

  bodymovin() {
    const tags = document.querySelectorAll("[data-bodymovin]");

    if (tags) {
      tags.forEach((tag) => {
        tag.addEventListener("inview", () => {
          if (!tag.classList.contains("loaded")) {
            const anim = tag.dataset.bodymovin;
            // const path = `${WPTEMPLATE}/static/bodymovin/${anim}/data.json`;
            fetch(anim).then((response) => {
              if (response.status == 200) {
                const l = lottie.loadAnimation({
                  container: tag,
                  renderer: "svg",
                  loop: true,
                  autoplay: true,
                  path: anim,
                });
                tag.classList.add("loaded");
                tag.lottie = l;
              }
            });
          } else if (tag.lottie) {
            tag.lottie.play();
          }
        });

        tag.addEventListener("outview", () => {
          if (tag.lottie) {
            tag.lottie.pause();
          }
        });
      });
    }
  }

  async sliderScreen() {
    const elts = document.querySelectorAll('.app-slider-screen')

    if( elts ) {
      elts.forEach(slider => {
        let timerSlider = 0;
        let current = -1;

        gsap.set(document.querySelector('html'), {
          background : '#FFF'
        })

        window.addEventListener('resize', () => {
          if(window.innerWidth < 1920) {
            gsap.set(slider, {
              width : '1920px',
              height: '1080px',
              position: 'fixed',
              top: '50%',
              left: '50%',
              y : '-50%',
              x : '-50%',
              scale : window.innerWidth / 1920
            })
          }
        })
        window.dispatchEvent(new Event('resize'))

        /** DEBUG */
        const debugSelect = document.querySelector('.select-slides');
        if( debugSelect ) {
          debugSelect.addEventListener('change', () => {
            goto(parseInt(debugSelect.value), false);
          })
        } 
        window.addEventListener('keyup', (e) => {
          if(e.key == 'd') {
            if( HTML.classList.contains('show-debug') ) {
              HTML.classList.remove('show-debug');
              goto(current);
            } else {

              clearTimeout(timerSlider);
              // Show select
              HTML.classList.add('show-debug');
            }
          }
        })

        /** MESSAGES */
        let isPushShow = false;
        const data = { action : 'screen_msg'};
        const ajaxurl = slider.dataset.ajaxurl;
        // const transitionPush = lottie.loadAnimation({
        //   container: document.querySelector('.animation-push'),
        //   renderer: "svg",
        //   loop: false,
        //   autoplay: false,
        //   path: templateURI + '/static/bodymovin/push.json',
        // });

        async function showMsg() {
          const response = await fetch(ajaxurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
            },
            body: new URLSearchParams(data),
          })
          const output = await response.json();

          if( output.success && output.data ) {
            const data = output.data;

            // Check msg push
            const msgPush = slider.querySelector('.msg-push');
            if( msgPush ) {
              if( data.msg_push.display && data.msg_push.msg && data.msg_push.msg != '') {
                if( data.msg_push.title != '' )
                  msgPush.querySelector('.title').innerHTML = `<h4>${data.msg_push.title}</h4>`;
                else 
                  msgPush.querySelector('.title').innerHTML = '';
                
                msgPush.querySelector('.desc').innerHTML = `${data.msg_push.msg}`;
                await sleep(200);
                msgPush.classList.add('show')
                // if( !isPushShow ) {
                  await sleep(100);
                  // transitionPush.stop();
                  // transitionPush.play();
                // }

                isPushShow = true;

              } else {
                msgPush.classList.remove('show')
                isPushShow = false;
              }
            }

            // Check msg alert
            const msgAlert = slider.querySelector('.msg-alert');
            if( msgAlert ) {
              if( data.msg_alert.display && data.msg_alert.msg && data.msg_alert.msg != '') {
                msgAlert.querySelector('.desc').innerHTML = data.msg_alert.msg;
                await sleep(200);
                msgAlert.classList.add('show')
                clearTimeout(timerSlider);
              } else {
                if( msgAlert.classList.contains('show')) {
                  goto(current < 0 ? 0 : current);
                }
                msgAlert.classList.remove('show')
              }
            }
          }

          await sleep(5000);
          showMsg();
        }
        showMsg();

        /** SLIDER */
        const slides = slider.querySelectorAll('.item');
        const transitions = [];
        const colors = ['bleu', 'rose', 'jaune', 'rouge']
        for( let i = 0; i < colors.length; i++) {
          const transitionAnim = lottie.loadAnimation({
            container: document.querySelector('.transition-slider-screen'),
            renderer: "svg",
            loop: false,
            autoplay: false,
            path: templateURI + `/static/bodymovin/transition-${colors[i]}.json`,
          });

          transitions.push(transitionAnim);
        }

        function goto(index, timer = true) {

          const duration = slides[index].dataset.duration;

          if( index == current ) {
            timerSlider = setTimeout(() => {
              const next = index >= slides.length - 1 ? 0 : index + 1;
              goto(next);
            }, duration * 1000)
            return;
          }

          let delay = 0;

          if( current >= 0 ) {
            transitions[current%transitions.length].stop();
            transitions[current%transitions.length].play();

            const currentSlide = slides[current]

            gsap.to(currentSlide, {
              autoAlpha: 0,
              y: '-30%',
              ease : 'expo.in',
              onComplete : () => {
                const video = currentSlide.querySelector('video');
                if( video ) {
                  video.pause();
                }
                
                currentSlide.classList.remove('active');
              }
            })
            delay = 1.3;
          }

          const video = slides[index].querySelector('video');
          if( video ) {
            video.play();
          }
          slides[index].classList.add('active')
          gsap.fromTo(slides[index], 
            {
              y : '30%',
            },
            {
              autoAlpha : 1,
              y: '0%',
              ease : 'expo.out',
              duration: 0.5,
              delay,
              onComplete: () => {
                const next = index >= slides.length - 1 ? 0 : index + 1;
                current = index;
                if( timer ) {
                  timerSlider = setTimeout(() => {
                    goto(next);
                  }, duration * 1000)
                }
              }
            }
          )
        }

        goto(0);
      })
    }
  }

  gridHours() {
    const elts = document.querySelectorAll('.grid-hours');

    if( elts ) {
      elts.forEach(grid => {
        const start = new Date();
        start.setHours(grid.dataset.start);
        start.setMinutes(0);
        start.setSeconds(0);
        const end = new Date();
        if( grid.dataset.start > grid.dataset.end ) end.setDate(end.getDate() + 1)
        end.setHours(grid.dataset.end);
        end.setMinutes(0);
        end.setSeconds(0);
        let now = new Date();
        const child = grid.querySelector('.grid-full')
        const timer = grid.querySelector('.timer');

        gsap.set(child, {
            marginTop : `${grid.offsetHeight / 2}px`,
            y : `${(now-start) / (end-start) * -100}%`
        })
          
        /** Timer */
        setInterval(() => {
          now = new Date();
          const h = (now.getHours() <= 9 ? '0' : '') + now.getHours();
          const m = (now.getMinutes() <= 9 ? '0' : '') + now.getMinutes();
          const s = (now.getSeconds() <= 9 ? '0' : '') + now.getSeconds();
          timer.innerHTML = `${h}:${m}:${s}`;

          gsap.set(child, {
            marginTop : `${grid.offsetHeight / 2}px`,
            y : `${(now-start) / (end-start) * -100}%`
        })
        })
      })
    }
  }
}

window.addEventListener("DOMContentLoaded", () => {
  new App();
});
